import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";
import * as types from "../actions/subFinanceActions";
import * as errorActions from "@mnjsplatform/data/lib/actions/errorActions";

export function subFinanceEmailReducer(
    state = {
        isLoaded: false,
        inOperation: false,
        isError: false,
        isAuthenticated: false,
        errorText: null,
        appParams: {},
        fileLink: null
    },
    action
) {
    if (action.type === types.SUB_FINANCE_EMAILS_LINK_LOADED) {
        return Object.assign({}, state, {
            fileLink: action.data.fileLink
        })
    } else if (action.type === errorActions.ERROR_RAISED) {
        return Object.assign({}, state, {
            fileLink: null
        })
    }
    return state;
}

export function subFinanceEmailItems() {
    return combineReducers({
        SalaryChangeRept_POx_PersRept: createItemReducer('SalaryChangeEmail', 'SalaryChangeRept.POx_PersRept', false),
        SalaryChangeRept_POx_PersRept_Params: createItemReducerParams('SalaryChangeEmail', 'SalaryChangeRept.POx_PersRept'),
        YearBonusRept_POx_PersRept: createItemReducer('AnnualBonusEmail', 'YearBonusRept.POx_PersRept', false),
        YearBonusRept_POx_PersRept_Params: createItemReducerParams('AnnualBonusEmail', 'YearBonusRept.POx_PersRept')
    });
}